import Vue from "vue";
import {
  Camera,
  CropModal,
  zCameraModal,
  zDatePicker,
  zGuestForm,
  zGuestFormv2
} from "zoox-components";
import {
  CompanyFilterService,
  CompanyService,
  CountryService,
  documentTypesMixin,
  FieldsService,
  PersonService as SmckPersonService,
  RecognitionService,
  ReservationService,
  validationMixin
} from "smck-service";
import PaymentService from "@/service/payment-service";
import PersonService from "@/service/person-service";
import { FlashMessageService, Helper } from "zoox-infra";
import CaptureTypeModal from "@/components/shared/CaptureTypeModal";
import sessionMixin from "@/components/shared/mixins/sessionMixin";
import ReservationDataHeader from "@/components/shared/ReservationDataHeader";
import { ApiClient } from "zoox-infra";

import ConfirmationModal from "@/components/shared/ConfirmationModal";
import CompareModal from "@/components/shared/CompareModal";

import GenericDialog from "@/components/shared/GenericDialog";

import lodash from "lodash";
import find from "lodash/find";
import { mapActions, mapState } from "vuex";

export default {
  name: "TabletGuestForm",
  mixins: [validationMixin, documentTypesMixin, sessionMixin],
  components: {
    "z-date-picker": zDatePicker,
    "z-guest-form": zGuestForm,
    "z-guest-formv2": zGuestFormv2,
    "z-camera": zCameraModal,
    Camera,
    ReservationDataHeader,
    GenericDialog,
    ConfirmationModal,
    CompareModal
  },
  props: [
    "enableRecognition",
    "activeTab",
    "excludeOtherInfo",
    "enableZooxpay",
    "isQualifiedGuest",
    "orientationTexts",
    "fieldSettingsData"
  ],
  data() {
    return {
      isActive: false,
      camera: null,
      reconOpen: false,
      currentPicture: "",
      companyId: "",
      companyName: "",
      tabletId: "",
      apiClient: new ApiClient(),
      recognitionService: new RecognitionService(Vue),
      reservationService: new ReservationService(Vue),
      fieldsService: new FieldsService(Vue),
      companyService: new CompanyService(Vue),
      companyFilterService: new CompanyFilterService(),
      countryService: new CountryService(Vue),
      paymentService: new PaymentService(),
      personService: new PersonService(),
      smckPersonService: new SmckPersonService(),
      reservation: null,
      companyParams: null,
      additionalData: null,
      navigating: false,
      isLoading: false,
      fillByPerson: false,
      hasBeenSaved: false,
      documentSearch: {
        documentType: "",
        documentNumber: ""
      },
      isAccor: false,
      isSilbeck: false,
      isESolotion: false,
      showModalFillGuestError: false,
      showModalGuestFormError: false,
      showWarning: true,
      showModal: false,
      confirmationData: undefined,
      renderForm: true,
      isMinor: false,
      showModalConfirmation: false
    };
  },
  computed: {
    personalDataContentTranslation() {
      return this.countryService.contentTranslation(
        this.orientationTexts.personalData,
        this.$i18n.locale
      );
    },
    guestId() {
      return this.$route.params.guestId;
    },
    reservationId() {
      return this.$route.params.reservationId;
    },
    paramsReady() {
      return [
        "fieldSettingsData",
        "companyParams",
        "additionalData",
        "reservation"
      ].reduce((acc, data) => acc && this[data] !== null, true);
    },
    ...mapState([
      "currentGuest",
      "currentPhoto",
      "cameFromRecon",
      "isSamePersonFromRecon",
      "isQualifiedGuest",
      "isBackingStep",
      "isEditingOtherGuest"
    ])
  },
  watch: {
    activeTab: function(tab) {
      if (tab === 0) {
        this.resetValidation();
      }
    }
  },
  created() {},
  async beforeMount() {
    const $context = this;
    const company = $context.companyService.getLocalCompany(true);
    $context.companyId = company.id;
    $context.companyName = company.name;
    this.isAccor = company.type === "accor";
    this.isSilbeck = company.type === "silbeck";
    this.isESolotion = company.type === "esolution";
    $context.additionalData = await $context.fieldsService.getAdditionalData(
      $context.companyId
    );

    $context.companyParams = await $context.companyService.getFnrhFormSettings(
      $context.companyId
    );
  },
  async mounted() {
    Vue.$globalEvent.$on("isMinor", value => {
      this.isMinor = value;
    });
    this.$_gtagPlugin_trackEvent("ENTERED_GUEST_FORM", "PORTAL");
    const $context = this;

    if (
      !$context.isBackingStep &&
      (!$context.cameFromRecon ||
        ($context.cameFromRecon && !this.isSamePersonFromRecon))
    ) {
      $context.currentGuest.photoUrl = null;
      $context.$setCurrentPhoto("");
    }

    if ($context.currentPersonId) {
      $context
        .$autoFill(
          $context.$route.params.reservationId,
          $context.currentPersonId,
          $context.currentPhoto,
          true
        )
        .then(() => {
          $context.fillByPerson = true;
          return $context.getReservation(
            $context.$route.params.reservationId,
            $context.$route.params.guestId
          );
        });
    } else {
      $context.getReservation(
        $context.$route.params.reservationId,
        $context.$route.params.guestId
      );
    }

    Vue.$globalEvent.$on("guestOtherInfoSaved", () => {
      $context.navigating = true;
      $context.hasBeenSaved = true;
    });

    Vue.$globalEvent.$on("checkIsMinor", isChild => {
      if (isChild && this.isQualifiedGuest) {
        $context.$setIsQualifiedGuest(false);
        $context.currentGuest.personId = null;
      }
    });

    Vue.$globalEvent.$on("guestValidationError", () => {
      if ($context && $context.$refs && $context.$refs.guestForm) {
        $context.$refs.guestForm.validateForm();
      }
    });

    Vue.$globalEvent.$on("guestFormSubmitError", () => {
      this.showModalGuestFormError = true;
    });

    Vue.$globalEvent.$on("resetGuestForm", value => {
      if (value) {
        $context.currentGuest = value.guest;
        $context.$setCurrentGuest(value.guest);
        $context.reservation = value.reservation;
        $context.$setCurrentReservations(value.reservation);
      }
      $context.hasBeenSaved = false;
    });

    Vue.$globalEvent.$on("tabChanged", ev => {
      if ($context.navigating || $context.hasBeenSaved) {
        return;
      }

      $context.navigating = true;
      if (this.isQualifiedGuest) {
        if ($context && $context.$refs && $context.$refs.guestForm) {
          $context.$refs.guestForm
            .saveGuest()
            .then(() => {
              if ([0, 1].includes(ev.previousTab)) {
                FlashMessageService.success(
                  $context.$root.$t("GLOBAL.SUCCESS_UPDATE_MESSAGE")
                );
              }
              $context.navigating = false;
            })
            .catch(err => {
              if (err) {
                FlashMessageService.warning(err);
              } else {
                FlashMessageService.warning(
                  $context.$root.$t("GLOBAL.INVALID_GUEST_NAVIGATION")
                );
              }

              ev.tabs.changeTab(0);
            })
            .then(() => {
              $context.navigating = false;
            });
        }
      } else {
        FlashMessageService.success(
          $context.$root.$t("GLOBAL.SUCCESS_UPDATE_MESSAGE")
        );
        $context.navigating = false;
      }
    });

    setTimeout(() => {
      $("input,select").each(function(i) {
        if ($context.type !== "hidden") {
          const $input = $(this);
          const strAux = `${new Date().getTime()}-${i}`;
          const name = $input.attr("name") || "";
          $input.attr("name", `${name}-${strAux}`);
          $input.attr("tabindex", i + 1);
          $input.attr("autocomplete", `no-autocomplete-${strAux}`);
        }
      });
    }, 1500);

    $context.resetValidation();
  },
  methods: Object.assign({
    ...mapActions([
      "$setCurrentReservation",
      "$setIsQualifiedGuest",
      "$setCurrentGuest"
    ]),
    getAuthenticatedPersonbyId: async function() {
      let response = await this.reservationService.getOne(
        this.$route.params.reservationId
      );
      if (response) {
        let guest = null;

        for (let i = 0; i < response.guests.length; i++) {
          if (response.guests[i].id === this.guestId) {
            guest = response.guests[i];
            this.reservation = response;
            this.$setCurrentReservation(this.reservation);
          }
        }

        if (guest) {
          this.$setCurrentPhoto("");
          guest.photoUrl = guest.photoUrl || null;
        }

        this.$setCurrentReservation(this.reservation);

        await this.checkHasOrderAtCheckin({
          reservation: this.reservation,
          guest: guest
        });
        this.isLoading = false;
        this.fillByPerson = true;
        this.$emit("filled-by-person");

        let reservation = this.reservation;
        let newGuest = [];

        for (let i = 0; i < reservation.guests.length; i++) {
          const guest = reservation.guests[i];

          if (guest.id === this.guestId) {
            newGuest.push(
              Object.assign({}, guest, {
                documentNumber:
                  guest.documentNumber || this.documentSearch.documentNumber,
                documentTypeId:
                  guest.documentTypeId || this.documentSearch.documentType.value
              })
            );
          } else {
            newGuest.push(guest);
          }
        }

        reservation = Object.assign({}, reservation, {
          guests: newGuest
        });

        this.$setCurrentReservation(reservation);
        this.reservation = reservation;

        this.isLoading = false;
        this.fillByPerson = true;
        this.$emit("filled-by-person");
      }
    },
    documentSubmit: function() {
      if (
        this.documentSearch.documentType.value == 1 &&
        this.companyParams.uniqueCpfPerGuestValidation
      ) {
        const { guests } = this.currentReservation;
        guests.forEach(guest => {
          if (
            guest.documentTypeId &&
            guest.documentTypeId == 1 &&
            guest.documentNumber &&
            guest.id != this.guestId
          ) {
            if (guest.documentNumber == this.documentSearch.documentNumber) {
              FlashMessageService.error(
                this.$t("GUEST_FORM.DUPLICATE_CPF_ERROR")
              );
              throw this.$t("GUEST_FORM.DUPLICATE_CPF_ERROR");
            }
          }
        });
      }
      if (this.$refs.documentForm.validate()) {
        this.isLoading = true;
        const currentGuest = find(
          this.currentReservation.guests,
          item => item.id === this.guestId
        );

        this.searchPersonByDoc(
          currentGuest,
          this.reservationId,
          this.guestId,
          this.documentSearch.documentNumber,
          this.documentSearch.documentType.value,
          this.documentSearch.birthdate
        )
          .then(() => {
            this.isLoading = false;
            this.fillByPerson = true;
            this.$emit("filled-by-person");
          })
          .catch(() => {
            let reservation = this.reservation;
            let newGuest = [];

            for (let i = 0; i < reservation.guests.length; i++) {
              const guest = reservation.guests[i];

              if (guest.id === this.guestId) {
                newGuest.push(
                  Object.assign({}, guest, {
                    documentNumber:
                      guest.documentNumber ||
                      this.documentSearch.documentNumber,
                    documentTypeId:
                      guest.documentTypeId ||
                      this.documentSearch.documentType.value,
                    birthdate: guest.birthdate || this.documentSearch.birthdate
                  })
                );
              } else {
                newGuest.push(guest);
              }
            }

            reservation = Object.assign({}, reservation, {
              guests: newGuest
            });

            this.$setCurrentReservation(reservation);
            this.reservation = reservation;

            this.isLoading = false;
            this.fillByPerson = true;
            this.$emit("filled-by-person");
          });
      }
    },
    fillByDocument: function() {
      this.$_gtagPlugin_trackEvent("FILL_BY_DOCUMENT", "PORTAL", this.guestId);
      const currentGuest = this.$refs.guestForm.currentGuest;
      if (currentGuest.documentNumber) {
        this.showWarning = false;
        this.searchPersonByDoc(
          currentGuest,
          this.reservationId,
          this.guestId,
          currentGuest.documentNumber,
          currentGuest.documentTypeId,
          currentGuest.birthdate
        )
          .then(guest => {
            const company = this.companyService.getLocalCompany();
            if (company.type === "accor") {
              guest.extraFields = currentGuest.extraFields;
            }
            this.$refs.guestForm.setGuest(guest);
          })
          .catch(() => {
            this.showWarning = true;
            this.showModalFillGuestError = true;
          });
      }
    },
    searchPersonByDoc: function(
      currentGuest,
      reservationId,
      guestId,
      documentNumber,
      documentTypeId,
      birthdate
    ) {
      const $context = this;
      return new Promise((resolve, reject) => {
        $context.reservationService
          .searchPersonWithGuestId(
            reservationId,
            guestId,
            documentNumber,
            documentTypeId,
            birthdate
          )
          .then(async reservation => {
            if (reservation && reservation.statusCode === 200) {
              let guest = null;

              for (let i = 0; i < reservation.guests.length; i++) {
                if (reservation.guests[i].id === this.guestId) {
                  guest = reservation.guests[i];
                }
              }
              if (guest) {
                let countries = await this.countryService.getAll(
                  "",
                  guest.countryId
                );
                guest.countryName = countries[0].name;
                if (guest.personId !== currentGuest.personId) {
                  $context.$setCurrentPhoto("");
                  guest.photoUrl = guest.photoUrl || null;
                } else {
                  guest.photoUrl = currentGuest.photoUrl || guest.photoUrl;
                }

                for (let i = 0; i < $context.reservation.guests.length; i++) {
                  if ($context.reservation.guests[i].id === guest.id) {
                    $context.reservation.guests[i] = guest;
                    break;
                  }
                }
              }

              // atualiza a reserva do storage
              $context.reservationService.setLocalReservation(
                $context.reservation
              );

              $context.$setCurrentReservation($context.reservation);
              this.$setCurrentPersonId(guest.personId);
              await this.checkHasOrderAtCheckin({
                reservation: $context.reservation,
                guest: guest
              });
              resolve(guest);
            } else {
              this.showDataNotFoundWarning();
              reject(null);
            }
          })
          .catch(err => {
            this.showDataNotFoundWarning();
            reject(err);
          });
      });
    },
    checkFieldBelow() {
      if (this.documentSearch.documentNumber) {
        let x = this.documentSearch.documentType;
        let y = this.documentSearch.documentNumber;

        this.documentSearch.documentType = x;
        let mask = documentTypesMixin.methods.getDocumentMask(
          this.documentSearch.documentType.value
        );

        if (mask !== "") {
          this.documentSearch.documentNumber = "";
          for (var i = 0, j = 0; i < mask.length; i++) {
            if (mask.charAt(i) === "#") {
              this.documentSearch.documentNumber += y.charAt(j);
              j++;
            } else {
              this.documentSearch.documentNumber += mask.charAt(i);
            }
          }
        } else {
          this.documentSearch.documentNumber = y;
        }
      }
      this.$refs.documentForm.validate();
    },
    showDataNotFoundWarning: function() {
      if (this.showWarning) {
        FlashMessageService.warning(this.$t("GLOBAL.DATA_NOT_FOUND"));
      }
    },
    getReservation: async function(reservationId) {
      const $context = this;
      const autofillData = $context.reservationService.getLocalReservation();

      $context.reservation = autofillData;
      if (reservationId !== autofillData.id) {
        $context.reservation = await $context.reservationService.getOne(
          reservationId
        );
      }

      const guestDocumentData =
        $context.guestDocumentData[$context.guestId] || {};

      const masterGuest = $context.reservation.guests.find(g => g.masterGuest);

      const emailPool = [masterGuest.email];

      $context.reservation.guests = $context.reservation.guests.map(
        (guest, index) => {
          if (guest.id === $context.guestId) {
            if ($context.isQualifiedGuest) {
              if (guest.fnrhId) {
                $context.$router.push({ name: "Success" });
              }

              $context.fillByPerson = guest.documentNumber ? true : false;

              guest.email == null && Object.assign(guest, { email: "" });

              let email =
                guest.ota !== "N/A" || guest.email.includes("*")
                  ? $context.reservation.guests[index].email
                  : guest.email;

              let newGuest = Object.assign(
                {},
                $context.reservation.guests[index],
                guest,
                {
                  documentTypeId:
                    typeof guest.documentTypeId === "number"
                      ? guest.documentTypeId
                      : guestDocumentData.documentTypeId,
                  documentNumber:
                    guest.documentNumber || guestDocumentData.documentNumber,
                  email:
                    !guest.masterGuest && emailPool.indexOf(email) > -1
                      ? ""
                      : email
                }
              );
              if (newGuest.email) {
                emailPool.push(email);
              }
              $context.$setCurrentGuest(newGuest);
              $context.renderForm = false;
              $context.$forceUpdate();
              $context.renderForm = true;
              return newGuest;
            } else {
              let newGuest = Object.assign({}, guest);
              if (!newGuest.email || newGuest.email.includes("*"))
                newGuest.email = null;

              if (this.isEditingOtherGuest) {
                newGuest.email = "";
                newGuest.name = "";
                newGuest.lastName = "";
                newGuest.fullName = "";
                newGuest.gender = "";
                newGuest.countryId = "";
              }

              $context.$setCurrentGuest(newGuest);
              $context.renderForm = false;
              $context.renderForm = true;
              $context.$forceUpdate();
              return newGuest;
            }
          }
          return guest;
        }
      );
      if (
        $context.reservation.order &&
        $context.reservation.order.chargesAtCheckin &&
        $context.reservation.order.chargesAtCheckin.length
      ) {
        const warrantyRegistrationCharges = $context.reservation.order.chargesAtCheckin.filter(
          c => c.metadata.type === "warranty_registration"
        );

        const lastCharge = lodash.orderBy(
          warrantyRegistrationCharges,
          ["updateAt"],
          ["desc"]
        )[0];

        if (
          lastCharge &&
          lastCharge.metadata &&
          lastCharge.metadata.origin === "at_checkin"
        ) {
          lastCharge.order = JSON.parse(
            JSON.stringify($context.reservation.order)
          );
          this.$emit("chargeToPayAtCheckinReceived", lastCharge);
        }
      }
      $context.$setCurrentReservation($context.reservation);
    },
    requestPhotoHandler: function() {
      if (!this.isMobile && !this.isIE) {
        this.$openModal(
          CaptureTypeModal,
          {
            canCancel: ["x", "escape"],
            scroll: "clip"
          },
          {}
        ).then(result => {
          if (result && typeof result === "number") {
            if (result === 1) {
              this.openFileUpload();
            } else {
              if (this.mediaSupported) {
                this.reconOpen = true;
              } else {
                FlashMessageService.warning(
                  this.$t("GLOBAL.CAMERA_NOT_SUPPORTED")
                );
              }
            }
          }
        });
      } else {
        // this.openFileUpload();

        //camera mobile
        if (this.mediaSupported) {
          this.reconOpen = true;
        } else {
          FlashMessageService.warning(this.$t("GLOBAL.CAMERA_NOT_SUPPORTED"));
        }
      }
    },

    closeConfirmModal: function(biometricsAccepted) {
      const currentGuest = this.$refs.guestForm.currentGuest;
      currentGuest.biometricsAccepted = biometricsAccepted;
      this.showModalConfirmation = false;
      this.$forceUpdate();
    },

    reconSuccess: function(result) {
      this.$_gtagPlugin_trackEvent("GUEST_FORM_REKOGNITION_SUCCESS", "PORTAL");
      this.$setCurrentPhoto(result.image);
      this.reconOpen = false;

      const isChild = JSON.parse(localStorage.age).isChild;
      if (!isChild) {
        this.showModalConfirmation = true;
      }
    },

    openFileUpload: function() {
      document.getElementById("file").click();

      const input = document.querySelector('input[id="file"]');
      const file = input.files[0];

      if (file) {
        let reader = new FileReader();
        reader.onload = function() {
          this.showModalConfirmation = true;
        };
      }
    },
    fileChangeEvent: function(fileInput) {
      const self = this;

      // https://nsulistiyawan.github.io/2016/07/11/Fix-image-orientation-with-Javascript.html

      if (
        fileInput.target &&
        fileInput.target.files &&
        fileInput.target.files.length > 0
      ) {
        loadImage.parseMetaData(fileInput.target.files[0], function(data) {
          var orientation = 0;
          if (data.exif) {
            orientation = data.exif.get("Orientation");
          }
          loadImage(
            fileInput.target.files[0],

            function(canvas) {
              var base64data = canvas.toDataURL("image/jpeg");

              var ctx = canvas.getContext("2d");
              switch (orientation) {
                case 8:
                  ctx.rotate((90 * Math.PI) / 180);
                  break;
                case 3:
                  ctx.rotate((180 * Math.PI) / 180);
                  break;
                case 6:
                  ctx.rotate((-90 * Math.PI) / 180);
                  break;
              }
              self.openCropModal(base64data);
            },
            {
              canvas: true,
              orientation: orientation,
              maxWidth: 512
            }
          );
        });
      }
    },
    openCropModal: function(imageData) {
      this.$openModal(
        CropModal,
        {
          canCancel: ["x", "escape"],
          scroll: "clip"
        },
        {
          imageData: imageData,
          skipCrop: true
        }
      ).then(result => {
        // precisamos limpar o valor do file input para se usuário quiser selecionar de novo mesma foto conseguir
        const fileInput = document.getElementById("file");

        if (fileInput) {
          fileInput.value = null;
        }

        if (result) {
          const size = Helper.base64FileSize(result);

          if (size <= 1024) {
            this.$setCurrentPhoto(result);
          } else {
            FlashMessageService.warning(this.$t("GLOBAL.IMAGE_TOO_LARGE_MSG"));
          }
        }
      });
    },

    async checkReservation(resp) {
      const guest = this.currentReservation.guests.find(
        guest => guest.id === resp.guest.id
      );
      if (!this.currentGuest.masterGuest) {
        const phoneNumber = `${guest.mobileCountryCode}${guest.mobileCityCode}${guest.mobilePhoneNumber}`;
        const { exists } = await this.apiClient.get(
          `reservation/${this.currentReservation.id}/check-duplicate-info?email=${guest.email}&mobilePhoneNumber=${phoneNumber}&guestId=${guest.id}`,
          true,
          false
        );

        if (exists == true) {
          this.showModal = true;
        } else {
          this.successHandler(resp);
        }
      } else {
        this.successHandler(resp);
      }
    },
    async successHandler(resp) {
      this.showModal = false;

      Object.keys(resp.guest).forEach(key => {
        this.currentGuest[key] = resp.guest[key];
      });

      this.$setCurrentReservation(resp.reservation);

      this.$setCurrentGuest(this.currentGuest);

      this.reservationService.setGuestImage(
        resp.reservation,
        resp.guest,
        this.$store.state.currentPhoto
      );

      this.$emit("tabChange", 1);
      this.hasBeenSaved = true;
      if (!this.navigating && resp && resp.reservation && resp.guest) {
        this.$_gtagPlugin_trackEvent(
          "SAVED_GUEST_FORM",
          "PORTAL",
          this.guestId
        );
        this.navigating = true;

        this.$setCurrentPersonId(resp.guest.personId);

        FlashMessageService.success(
          this.$root.$t("GLOBAL.SUCCESS_UPDATE_MESSAGE")
        );
      }

      this.navigating = false;
    },
    emitErrorForUser() {
      FlashMessageService.clear();
      FlashMessageService.error(this.$t("GUEST_FORM.FILL_REQUIRED_FIELDS"));
    },
    failHandler: function() {
      this.$emit("tabChange", 0);
    },
    resetValidation: function() {
      const $context = this;
      setTimeout(() => {
        if (
          $context.$refs &&
          $context.$refs.guestForm &&
          $context.$refs.guestForm.$refs &&
          $context.$refs.guestForm.$refs.guestForm
        ) {
          $context.$refs.guestForm.$refs.guestForm.resetValidation();
        }
      }, 500);
    },
    async checkHasOrderAtCheckin({ reservation, guest: currentGuest }) {
      if (this.enableZooxpay && currentGuest.masterGuest) {
        const personTempLoginResp = await this.personService.tempLogin(
          currentGuest.personId
        );
        if (personTempLoginResp && personTempLoginResp.id) {
          const orderResp = await this.paymentService.getOrdersToChargeAtCheckin(
            {
              companyId: reservation.companyId,
              code: reservation.reservationNumber,
              status: "open",
              closed: false
            }
          );
          if (this.checkHasChargesAtCheckin(orderResp)) {
            const query = {
              companyId: reservation.companyId,
              metadataType: "warranty_registration",
              orderId: orderResp.data[0].id,
              status: "pending"
            };
            const chargeResp = await this.paymentService.getPayments(query);
            if (chargeResp && chargeResp.data && chargeResp.data.length > 0) {
              const maskMobileCityCode = currentGuest.mobilePhoneMask
                ? currentGuest.mobilePhoneMask.split(" ")[0]
                : "";
              const lastIndexMobileCityCode =
                maskMobileCityCode.length >= 4
                  ? maskMobileCityCode.length - 2
                  : maskMobileCityCode.length;
              let phoneNumber;
              if (
                currentGuest.mobileCityCode &&
                currentGuest.mobilePhoneNumber &&
                !(
                  currentGuest.mobilePhoneNumber.substring(
                    0,
                    lastIndexMobileCityCode
                  ) === currentGuest.mobileCityCode
                )
              ) {
                phoneNumber =
                  currentGuest.mobileCountryCode +
                  currentGuest.mobileCityCode +
                  currentGuest.mobilePhoneNumber;
              } else {
                phoneNumber =
                  currentGuest.mobileCountryCode +
                  currentGuest.mobilePhoneNumber;
              }

              const charge = chargeResp.data[0];
              const chargeUpdatedResp = await this.paymentService.updatePersonCharge(
                currentGuest.personId,
                charge.token,
                currentGuest.name,
                phoneNumber,
                currentGuest.email
              );
              if (chargeUpdatedResp && chargeUpdatedResp.updated) {
                charge.customer.id = currentGuest.personId;
                this.$emit("chargeToPayAtCheckinReceived", charge);
              }
            }
          }
        }
      }
    },
    checkHasChargesAtCheckin(orderResp) {
      return (
        orderResp &&
        orderResp.data &&
        orderResp.data.length > 0 &&
        orderResp.data[0].chargesAtCheckin &&
        orderResp.data[0].chargesAtCheckin.length > 0
      );
    },
    nextWithoutSendData() {
      Vue.$globalEvent.$emit("tabChange", 1);
    }
  })
};
